import axios from 'axios'
import Vue from 'vue'

function initialState() {
  return {
    valueTypelist: ['double', 'equation', 'range'],
    guidelineConfig: {
      data: {},
      isLoading: false,
    },
    guidelineDefaultValues: {
      data: [],
      isLoading: false,
    },
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getGuidelineConfig({
      commit,
      state,
    }, options) {
      if (options.forced || !state.guidelineConfig.data || !state.guidelineConfig.data.DataFetchStrategy) {
        try {
          state.guidelineConfig.isLoading = true
          let res = await axios.get('api/AdminGuideline/GuidelineConfig')
          commit('SET_GUIDELINE_CONFIG', res.data)
          options.successCb(res.data)
        } catch (error) {
          options.failedCb(error.message, error)
        } finally {
          state.guidelineConfig.isLoading = false
        }
      } else {
        options.successCb(state.guidelineConfig.data)
      }
    },
    async UpdateTenantDefaultStrategy({
      commit,
    }, options) {
      var url = 'api/CoFactor/UpdateTenantDefaultStrategy'
      await axios.post(url, options.data)
        .then(res => {
          commit('UpdateTenantDefaultStrategy', res)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async getGuidelineAnalyteDefaultValues({
      commit,
      state,
    }, options) {
      let strategy
      if (options && options.params && options.params.strategy) {
        strategy = options.params.strategy
      }
      if (options.forced || !state.guidelineDefaultValues.data || state.guidelineDefaultValues.data.length == 0 || strategy) {
        try {
          let params = {}
          if (strategy) {
            params.strategy = strategy
          }
          let res = await axios.get('api/AdminGuideline/DefaultValues', {
            params,
          })
          if (!strategy) {
            commit('SET_GUIDELINE_DEFAULT_VALUES', res.data)
          }
          options.successCb(res.data)
        } catch (error) {
          options.failedCb(error.message, error)
        }
      } else {
        options.successCb(state.guidelineDefaultValues.data)
      }
    },
  },

  mutations: {
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    SET_GUIDELINE_CONFIG(state, data) {
      Vue.set(state.guidelineConfig, 'data', data)
    },
    SET_GUIDELINE_DEFAULT_VALUES(state, data) {
      Vue.set(state.guidelineDefaultValues, 'data', data)
    },
    UpdateTenantDefaultStrategy(state, data) {
      let newData = {
        TenantId: data.data.TenantId,
        DataFetchStrategy: data.data.StrategyCode,
      }
      Vue.set(state.guidelineConfig, 'data', newData)
    },
  },

  getters: {
    guidelineDefaultValueByName: state => name => {
      return state.guidelineDefaultValues.data.find(x => x.AnalyteName == name)
    },
    valueTypelist: s => s.valueTypelist,
  },
}